<script setup>
import { computed } from "vue";
import { AvatarRoot, AvatarImage, AvatarFallback } from "radix-vue";

const props = defineProps({
  variant: {
    type: Object,
    required: true,
    default: () => { },
  },
});

defineEmits(["onProductClick"]);

const fallbackLabel = computed(() => {
  const name = props.variant?.opt1 || "";
  return name.trim() ? name.trim().slice(0, 2).toUpperCase() : "NA";
});

const stockStatus = computed(() => {
  if (props.variant?.available_stock && props.variant?.MaxOrderQty > 0) {
    return "In Stock";
  }

  if (props.variant?.first_landed_date == null) {
    return "Coming Soon";
  }

  return "Out of Stock";
});

const stockStatusClass = computed(() => {
  return stockStatus.value === "Out of Stock"
    ? "text-brand-red"
    : "text-brand-gray";
});
</script>
<template>
  <td>
    <div class="flex items-center gap-3 cursor-pointer" @click="$emit('onProductClick')">
      <AvatarRoot
        class="w-12 h-12 border border-theme-border border-opacity-60 rounded bg-white flex-shrink-0 overflow-hidden">
        <AvatarImage class="w-full h-full object-contain object-center" :src="variant.image_thumbnail"
          :alt="variant.opt1" />
        <AvatarFallback
          class="w-full h-full flex items-center justify-center bg-gray-100 text-theme-body text-xxs font-medium uppercase">
          {{ fallbackLabel }}
        </AvatarFallback>
      </AvatarRoot>
      <div class="flex flex-col items-start justify-start">
        <p class="text-sm text-theme-secondary flex-grow">
          {{ variant.opt1 }}
        </p>
        <span class="text-xxs uppercase flex-shrink-0" :class="stockStatusClass">
          {{ stockStatus }}
        </span>
      </div>
    </div>
  </td>
</template>
